export default "__VITE_ASSET__CYhbPuTG__"